import { z } from 'zod'
import { oc } from '@orpc/contract'

export const CONSENT_FIELD_KEYS = [
  'addressLine',
  'city',
  'state',
  'zip',
  'representativeName',
  'relationship',
  'signature',
] as const
export type ConsentFieldKey = (typeof CONSENT_FIELD_KEYS)[number]

export const CONSENT_REQUIRED_FIELDS = ['signature'] as const satisfies readonly ConsentFieldKey[]

// Optional fields accept '' — the patient clearing a prefilled cell is a
// deliberate blank, not a validation error. Required fields are enforced
// against the rendered document (missingRequiredConsentFields).
export const consentFieldsSchema = z.object({
  addressLine: z.string().trim().optional(),
  city: z.string().trim().optional(),
  state: z.string().trim().optional(),
  zip: z.string().trim().optional(),
  representativeName: z.string().trim().optional(),
  relationship: z.string().trim().optional(),
  signature: z.string().trim().optional(),
})

export const consentSign = oc
  .route({ method: 'POST', path: '/v2/consent/sign' })
  .input(
    z.object({
      organizationId: z.string(),
      // ip / userAgent are NOT accepted from the client — they're part of the
      // consent audit trail and are derived server-side (see consent-sign.handler.ts).
      isRejected: z.boolean().optional(),
      patientHasReadConsent: z.boolean().optional(),
      fields: consentFieldsSchema.optional(),
    }),
  )
  .output(z.object({ isSigned: z.boolean() }))
